<script>
	import GameView from "./gameView.svelte";
	import PlayerList from "./playerList.svelte";
	import AdminView from "./adminView.svelte";
	import CheatSheet from "./cheatSheet.svelte";

	export let isAdmin = false;
</script>

<div>
	<div class="title">
		<span class="mono">/regex/</span> game
	</div>
	<div class="container">
		<div class="players"><CheatSheet /></div>
		<div class="game"><GameView /></div>
		<div class="players"><PlayerList /></div>
	</div>
	{#if isAdmin}
		<AdminView />
	{/if}
</div>

<style>
	.title {
		font-size: 32px;
		margin-top: 30px;
	}

	.mono {
		font-family: var(--font-family-mono);
	}

	.container {
		display: flex;
		margin:  auto;
		justify-content: space-around;
	}

	.game {
		width: 60%;
		margin-top: 60px;
	}

	.players {
		width: 30%;
		max-width: 250px;
	}
</style>
